import {

  ADD_SERVICE,
  ADD_SERVICE_FAILURE,
  ADD_SERVICE_SUCCESS,
  DELETE_SERVICE,
  DELETE_SERVICE_FAILURE,
  DELETE_SERVICE_SUCCESS,
  EDIT_SERVICE,
  EDIT_SERVICE_FAILURE,
  EDIT_SERVICE_SUCCESS,

  GET_ALL_PAGE_SERVICES,
  GET_ALL_PAGE_SERVICES_FAILURE,
  GET_ALL_PAGE_SERVICES_SUCCESS,

  GET_SERVICE,
  GET_SERVICE_FAILURE,
  GET_SERVICE_SUCCESS
} from "./actionTypes";

export const getAllPageServices = (payload) => {
  return {
    type: GET_ALL_PAGE_SERVICES,
    payload: payload,
  };
}

export const getAllPageServicesSuccess = (payload) => {
  return {
    type: GET_ALL_PAGE_SERVICES_SUCCESS,
    payload: payload,
  };
}

export const getAllPageServicesFailure = (error) => {
  return {
    type: GET_ALL_PAGE_SERVICES_FAILURE,
    payload: error,
  };
}

export const getService = (payload) => {
  return {
    type: GET_SERVICE,
    payload: payload,
  };
}

export const getServiceSuccess = (payload) => {
  return {
    type: GET_SERVICE_SUCCESS,
    payload: payload,
  };
}

export const getServiceFailure = (error) => {
  return {
    type: GET_SERVICE_FAILURE,
    payload: error,
  };
}

export const addService = (payload) => {
  return {
    type: ADD_SERVICE,
    payload: payload,
  };
}
export const addServiceSuccess = (payload) => {
  return {
    type: ADD_SERVICE_SUCCESS,
    payload: payload,
  };
}

export const addServiceFailure = (error) => {
  return {
    type: ADD_SERVICE_FAILURE,
    payload: error,
  };
}

export const editService = (payload) => {
  return {
    type: EDIT_SERVICE,
    payload: payload,
  };
}
export const editServiceSuccess = (payload) => {
  return {
    type: EDIT_SERVICE_SUCCESS,
    payload: payload,
  };
}

export const editServiceFailure = (error) => {
  return {
    type: EDIT_SERVICE_FAILURE,
    payload: error,
  };
}

export const deleteService = (payload) => {
  return {
    type: DELETE_SERVICE,
    payload: payload,
  };
}
export const deleteServiceSuccess = (payload) => {
  return {
    type: DELETE_SERVICE_SUCCESS,
    payload: payload,
  };
}

export const deleteServiceFailure = (error) => {
  return {
    type: DELETE_SERVICE_FAILURE,
    payload: error,
  };
}

